import { render, staticRenderFns } from "./FormField.vue?vue&type=template&id=c7b97112&"
import script from "./FormField.vue?vue&type=script&lang=js&"
export * from "./FormField.vue?vue&type=script&lang=js&"
import style0 from "./FormField.vue?vue&type=style&index=0&lang=postcss&"
import style1 from "./FormField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SbRichText: require('/opt/build/repo/components/common/SbRichText.vue').default})
